import { analytics } from './analyticsClient';

import type { AnalyticsClient } from './analyticsClient';

// Lo que se lee del usuario de whoami (auth.user); el resto de sus campos no interesa aquí.
type IdentityUser = { guid?: string; schools?: ReadonlyArray<{ guid?: string | null } | null> | null } | null | undefined;
type SyncIdentity = (user: IdentityUser, language: string | null | undefined) => void;

export function createIdentitySync(client: AnalyticsClient): SyncIdentity {
  // Por carga del JS: un login sin recargar cuenta como apertura, un logout y vuelta a entrar no.
  let hasTrackedAppOpened = false;

  return function syncIdentity(user: IdentityUser, language: string | null | undefined): void {
    if (!user) {
      client.identify(null);
      return;
    }

    client.identify({ language, schoolGuid: user.schools?.[0]?.guid });
    if (!hasTrackedAppOpened) hasTrackedAppOpened = client.track('app_opened', {});
  };
}

export const syncAnalyticsIdentity = createIdentitySync(analytics);
